"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAdaptiveRender = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _react = require("react");
var useAdaptiveRender = function useAdaptiveRender() {
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)((typeof window !== 'undefined' ? window : {}).innerWidth),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  var updateWidth = (0, _react.useCallback)((0, _lodash["default"])(function () {
    return setWidth((typeof window !== 'undefined' ? window : {}).innerWidth);
  }, 100), [width]);
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      setLoading(false);
      window.addEventListener('resize', updateWidth);
      return function () {
        return window.removeEventListener('resize', updateWidth);
      };
    }
  }, []);
  return {
    width: width,
    loading: loading
  };
};
exports.useAdaptiveRender = useAdaptiveRender;